import { Navigate, type RouteObject } from "react-router";
import { h5Routes } from "./h5";
import { mainRoutes } from "./main";

export const routesSection: RouteObject[] = [
	// H5 Mall
	...h5Routes,
	// Main
	...mainRoutes,
	// No Match
	{ path: "*", element: <Navigate to="/404" replace /> },
];
